import { FSMCommonTransitions } from '../../constants'
import { QBFind, QBReview, QBOffers, QBOwnership, QBChooseAddress } from '../../../../pages/qb'
import { StateRoute } from '../../../../types/interface/fsm.interface'
import { FSMCommonStatePaths } from '../../routes'

const {
  QB_FIND,
  QB_REVIEW,
  QB_OWNER,
  QB_OWNERSHIP,
  QB_EXTRA_OFFERS,
  QB_EXTRA_OFFERS_LIST,
  QB_EXTRA_FIND_EMPTY,
  QB_EXTRA_FIND_CUSTOM,
  QB_CHOOSE_ADDRESS,
} = FSMCommonTransitions

export const FSMQBVehicleStatePathsNO = [
  {
    is: QB_FIND,
    page: QBFind,
  },
  {
    is: { [QB_OWNERSHIP]: QB_REVIEW },
    page: QBReview,
  },
  {
    is: { [QB_OWNERSHIP]: QB_OWNER },
    page: QBOwnership,
  },
  {
    is: { [QB_EXTRA_OFFERS]: QB_EXTRA_OFFERS_LIST },
    page: QBOffers,
  },
  {
    is: { [QB_EXTRA_OFFERS]: QB_EXTRA_FIND_EMPTY },
    page: QBFind,
  },
  {
    is: { [QB_EXTRA_OFFERS]: QB_EXTRA_FIND_CUSTOM },
    page: QBFind,
  },
]

export const FSMVehicleStatePathsNO: Array<StateRoute> = [
  ...FSMCommonStatePaths,
  ...FSMQBVehicleStatePathsNO,
]

export const FSMQBTravelStatePathsNO = [
  {
    is: QB_REVIEW,
    page: QBReview,
  },
]

export const FSMTravelStatePathsNO: Array<StateRoute> = [
  ...FSMCommonStatePaths,
  ...FSMQBTravelStatePathsNO,
]

export const FSMQBContentStatePathsNO = [
  {
    is: QB_REVIEW,
    page: QBReview,
  },
  {
    is: QB_FIND,
    page: QBFind,
  },
  {
    is: QB_CHOOSE_ADDRESS,
    page: QBChooseAddress,
  },
]

export const FSMContentStatePathsNO: Array<StateRoute> = [
  ...FSMCommonStatePaths,
  ...FSMQBContentStatePathsNO,
]
